import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";

export const itemCategoryfields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {
    const formFields = [
        {
            label: 'Name',
            key: 'name',
            type: 'text',
            placeholder: 'Name',
            visible: true,
            width: '25%'
        },
        {
            label: 'Type',
            key: 'type',
            type: 'select',
            placeholder: 'Type',
            visible: false,
            width: '25%',
            options: [
                { label: 'Item', value: 'item' },
                { label: 'Contact', value: 'contact' }
            ],
            value: 'item'
        },
        {
            label: 'Image',
            key: 'image_url',
            type: 'upload',
            visible: true,
            width: '100%',
            mimeType: "image/*",
            moduleName: moduleName,
        },
    ]

    const CustomFields = response.CustomFields;

    if (CustomFields && CustomFields.length > 0) {
        CustomFields.forEach((field) => {
            formFields.push({
                label: field.name,
                key: 'cf.' + field.key,
                type: field.type,
                placeholder: field.placeholder,
                visible: true,
                width: '25%'
            });
        });
    }

    return formFields;
}

export const itemCategoryMobileCard = (item, index, getFieldValue) => {
    return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
        <View>
            <Text>TEST</Text>
            <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
        </View>
    </Card>;
}

export const itemCategoryMain = {
    fields: itemCategoryfields,
    mobileCard: null
}